import { render, staticRenderFns } from "./attachedToCourseNote.vue?vue&type=template&id=0c83ed16&"
import script from "./attachedToCourseNote.vue?vue&type=script&lang=js&"
export * from "./attachedToCourseNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports